export default "__VITE_ASSET__Cyran$dq__"